<template>
  <div class="admin-container" :class="{ 'mobile-mode': isMobile }">
    <div 
      v-if="isMobile && isSidebarOpen" 
      class="sidebar-mask" 
      @click="isSidebarOpen = false"
    ></div>
    <el-container>
      <el-aside width="200px" class="sidebar" :class="{ 'sidebar-mobile-open': isSidebarOpen }">
        <div class="sidebar-header">
          <h1 class="page-title">物品管理后台</h1>
          <!-- 移动端侧边栏内部的关闭按钮 -->
          <i v-if="isMobile" class="el-icon-close mobile-close-btn" @click="isSidebarOpen = false"></i>
        </div>
        <el-menu :default-active="activeMenu" @select="handleSelect">
          <el-menu-item index="1">类目设置</el-menu-item>
          <el-menu-item index="2">图片空间</el-menu-item>
          <el-menu-item index="3">商品设置</el-menu-item>
          <!-- 新增首页图片设置菜单项 -->
          <el-menu-item index="6">首页图片设置</el-menu-item>
        </el-menu>
        <div class="personal-center">
          <el-menu :default-active="activeMenu" @select="handleSelect">
            <el-menu-item index="5">个人中心</el-menu-item>
            <!-- 添加退出登录按钮，并添加唯一类名 -->
            <el-menu-item index="logout" @click="logout" class="logout-button">
              <i class="el-icon-switch-button"></i>
              <span slot="title">退出登录</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-aside>

      <el-container>
        <el-main>
          <!-- 2. 添加移动端顶部的汉堡菜单按钮 -->
          <div class="mobile-header" v-if="isMobile">
            <el-button icon="el-icon-s-unfold" @click="toggleSidebar" size="small">菜单</el-button>
            <span class="mobile-title">管理后台</span>
          </div>
          <!-- 类目设置部分 -->
          <div v-if="activeMenu === '1'">
            <h2>类目设置</h2>
            <el-button type="primary" @click="openDialog" style="margin-bottom: 20px;">添加类目</el-button>
            <el-dialog title="添加类目" :visible.sync="dialogVisible" :width="dialogWidthSmall">
              <el-form>
                <el-form-item label="类目名称">
                  <el-input v-model="newCategoryName" placeholder="请输入类目名称"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="addCategory">确认</el-button>
              </span>
            </el-dialog>

            <el-dialog title="确认删除" :visible.sync="confirmDeleteDialogVisible" :width="dialogWidthSmall">
              <span>确定要删除该类目吗？此操作无法撤销。</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="confirmDeleteDialogVisible = false">取消</el-button>
                <el-button type="danger" @click="confirmDelete">确认删除</el-button>
              </span>
            </el-dialog>

            <!-- 添加修改类目对话框 -->
            <el-dialog title="修改类目" :visible.sync="editCategoryDialogVisible" :width="dialogWidthSmall">
              <el-form>
                <el-form-item label="类目名称">
                  <el-input v-model="editCategoryName" placeholder="请输入类目名称"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="editCategoryDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="updateCategory">确认修改</el-button>
              </span>
            </el-dialog>

            <div class="drag-list-container">
              <div class="drag-header">
                <div class="drag-header-item flex-start">类目名称</div>
                <div class="drag-header-item text-right">操作</div>
              </div>
              <draggable 
                v-model="categories" 
                @end="updateSortOrder"
                handle=".drag-handle"
                class="drag-list"
              >
                <div v-for="category in categories" :key="category.id" class="drag-item">
                  <div class="drag-item-content">
                    <div class="drag-item-left">
                      <i class="el-icon-rank drag-handle"></i>
                      <span class="item-name">{{ category.name }}</span>
                    </div>
                    <div class="drag-item-right">
                      <el-button type="primary" size="mini" @click="showEditDialog(category)" style="margin-right: 10px;">修改</el-button>
                      <el-button type="danger" size="mini" @click="showDeleteConfirm(category.id)">删除</el-button>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>

          <!-- 图片空间部分 -->
          <div v-else-if="activeMenu === '2'">
            <h2>图片空间</h2>
            <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
              <el-dropdown>
                <el-button type="primary">
                  选择文件夹<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" style="width: 300px; max-height: 300px; overflow-y: auto;">
                  <el-tree
                    ref="folderTree"
                    :data="folderStructure"
                    node-key="id"
                    :props="defaultProps"
                    highlight-current
                    @node-click="handleSingleSelect"
                  />
                </el-dropdown-menu>
              </el-dropdown>
              <el-button type="success" @click="openCreateFolderDialog" style="margin-left: 10px;">创建文件夹</el-button>
              <el-button type="danger" @click="deleteFolder" style="margin-left: 10px;">删除文件夹</el-button>
              <el-button type="warning" @click="triggerFileUpload" style="margin-left: 10px;">添加图片</el-button>
              <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/*" style="display: none;">
            </div>

            <div class="space-info">
              <!-- 已使用空间: {{ usedSpaceMB.toFixed(2) }} / {{ maxSpace }} MB -->
              已使用空间: {{ (Number(usedSpaceMB) / 1024).toFixed(2) }} / {{ (maxSpace / 1024).toFixed(2) }} GB
            </div>

            <el-dialog title="创建文件夹" :visible.sync="createFolderDialogVisible" :width="dialogWidthSmall">
              <el-form>
                <el-form-item label="文件夹名称">
                  <el-input v-model="newFolderName" placeholder="请输入文件夹名称"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="createFolderDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="createFolder">确认创建</el-button>
              </span>
            </el-dialog>

            <p v-if="selectedFolder">
              当前路径: {{ selectedFolder }}
              <span class="clear-button-circle" @click="clearSelectedFolder">
                <i class="el-icon-close"></i>
              </span>
            </p>

            <!-- 图片展示部分 -->
            <div v-if="imageFiles.length > 0" class="image-gallery">
              <div class="image-gallery-flex">
                <el-card
                  v-for="(image, index) in imageFiles"
                  :key="index"
                  shadow="hover"
                  class="image-card"
                >
                  <div class="image-container">
                    <img :src="image.url" class="image-preview" />
                  </div>
                  <div style="padding: 10px; text-align: center;">
                    <span>{{ image.name }}</span>
                    <div class="image-actions">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="renameImage(index, image)"
                        style="margin-right: 5px;"
                      >
                        重命名
                      </el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        @click="deleteImage(index, image)"
                      >
                        删除
                      </el-button>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
            <p v-else>当前文件夹无图片</p>

            <div class="pagination-container" v-if="imageFiles.length > 0 || totalImages > 0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalImages">
              </el-pagination>
            </div>
          </div>

          <!-- 商品设置部分 -->
          <div v-else-if="activeMenu === '3'">
            <h2>商品设置</h2>
            <el-button type="primary" @click="openAddProduct" style="margin-bottom: 20px;">添加商品</el-button>
            <!-- 新增批量删除按钮 -->
            <el-button type="danger" @click="confirmBatchDelete">批量删除</el-button> 
            <el-select v-model="selectedCategory" placeholder="选择类目" @change="fetchProducts" filterable default-first-option>
                <el-option
                    v-for="category in categories"
                    :key="category.id"
                    :label="category.name"
                    :value="category.id"
                ></el-option>
            </el-select>

            <div class="drag-list-container" v-if="products.length > 0">
                <div class="drag-header">
                    <!-- 调整全选框的样式和宽度 -->
                    <div class="drag-header-item" style="width: 40px; justify-content: center;">
                        <el-checkbox v-model="selectAll"></el-checkbox>
                    </div> 
                    <div class="drag-header-item flex-start">商品信息</div>
                    <!-- 调整操作列的宽度，与下方按钮对齐 -->
                    <div class="drag-header-item" style="width: 160px; text-align: center;">操作</div>
                </div>
                <draggable 
                    v-model="products" 
                    @end="updateProductSortOrder"
                    handle=".drag-handle"
                    class="drag-list"
                >
                    <div v-for="product in products" :key="product.id" class="drag-item product-drag-item">
                        <div class="drag-item-content">
                            <!-- 调整列表项选择框的样式，使其与表头对齐 -->
                            <div class="drag-item-left" style="width: 50px; justify-content: center;">
                                <el-checkbox v-model="product.checked"></el-checkbox>
                            </div> 
                            <div class="drag-item-left">
                                <i class="el-icon-rank drag-handle"></i>
                                <div class="product-info">
                                    <img :src="product.image" alt="商品图片" class="product-image" />
                                    <span class="item-name">{{ product.name }}</span>
                                    <span class="product-price">¥{{ product.price }}</span>
                                </div>
                            </div>
                            <!-- 调整操作按钮区的宽度，保持与表头对齐 -->
                            <div class="drag-item-right" style="width: 160px;">
                                <el-button type="primary" size="mini" @click="editProduct(product.id)">修改</el-button>
                                <el-button type="danger" size="mini" @click="confirmDeleteProduct(product.id)">删除</el-button>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
            <div v-else class="no-products">
                <p>请选择类目查看商品</p>
            </div>
        </div>

          <!-- 商品设置表单视图 -->
          <div v-if="activeMenu === '4'">
            <h2>{{ productSettingsMode === 'add' ? '添加商品' : '编辑商品' }}</h2>

            <!-- 商品信息设置部分 -->
            <h3 class="section-title">商品信息设置</h3>
            <el-form :model="productForm">
              <el-form-item label="所属类目">
                <el-select v-model="productForm.category_id" placeholder="请选择类目" filterable default-first-option>
                  <el-option
                    v-for="category in categories"
                    :key="category.id"
                    :label="category.name"
                    :value="category.id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="商品图片">
                <div class="image-selector" @click="openImageSelector('Images')">
                  <img v-if="productForm.image" :src="productForm.image" alt="商品图片" class="image-preview_add"/>
                  <i v-else class="el-icon-plus image-placeholder-icon"></i>
                </div>
              </el-form-item>

              <el-form-item label="商品名称">
                <el-input v-model="productForm.name" placeholder="请输入商品名称"></el-input>
              </el-form-item>

              <h3 class="section-title">详情页设置</h3>
              <el-form-item label="主图">
                <!-- 上传按钮和提示 -->
                <div class="upload-section">
                  <el-button type="primary" @click="openImageSelector('detailMainImages')" class="upload-button">点击上传</el-button>
                  <span class="upload-tip" style="color: red; margin-left: 10px;">(拖动图片可调整顺序，最多可选择 5 张图片)</span>
                </div>

                <!-- 拖拽排序的图片缩略图列表 -->
                <draggable 
                  v-model="productForm.detailMainImages" 
                  class="image-gallery-flex" 
                  :options="{ animation: 200 }" 
                  style="margin-top: 20px;"
                >
                  <el-card 
                    v-for="(image, index) in productForm.detailMainImages" 
                    :key="index" 
                    shadow="hover" 
                    class="image-card">
                    <div class="image-container">
                      <img :src="image" class="image-preview" />
                    </div>
                    <div class="image-actions">
                      <el-button 
                        type="danger" 
                        size="mini" 
                        @click="removeDetailMainImage(index)">删除</el-button>
                    </div>
                  </el-card>
                </draggable>

                <!-- 图片空间模态框 -->
                <el-dialog title="选择图片" :visible.sync="selectDetailMainImagesDialogVisible" :width="dialogWidthLarge">
                  <div style="display: flex; align-items: center; margin-bottom: 20px;">
                    <el-dropdown>
                      <el-button type="primary">
                        选择文件夹<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown" style="width: 300px; max-height: 300px; overflow-y: auto;">
                        <el-tree
                          ref="folderTree"
                          :data="folderStructure"
                          node-key="id"
                          :props="{ label: 'label', children: 'children' }"
                          highlight-current
                          @node-click="(folder) => selectFolder(folder, 'detailMainImages')"
                        />
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>

                  <!-- 图片展示区域 -->
                  <div class="image-gallery-flex">
                    <el-card
                      v-for="(image, index) in imageFiles"
                      :key="index"
                      shadow="hover"
                      class="image-card"
                      @click.native="confirmSelectDetailMainImage(image)"
                    >
                      <img :src="image.url" class="image-preview-small" />
                      <div class="image-name">{{ image.name }}</div>
                    </el-card>
                  </div>

                  <!-- 【新增】这里也要加分页，否则弹窗里只能看到前20张 -->
                  <div class="pagination-container" style="margin-top: 20px; text-align: center;">
                    <el-pagination
                      small
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      layout="total, prev, pager, next"
                      :total="totalImages">
                    </el-pagination>
                  </div>


                  <span slot="footer" class="dialog-footer">
                    <el-button @click="selectDetailMainImagesDialogVisible = false">取消</el-button>
                  </span>
                </el-dialog>
              </el-form-item>

              <el-form-item label="详情图">
                <!-- 上传按钮和提示 -->
                <div  class="upload-section">
                  <el-button type="primary" @click="openImageSelector('detailImages')" class="upload-button">点击上传</el-button>
                  <span class="upload-tip" style="color: red; margin-left: 10px;">(拖动图片可调整顺序)</span>
                </div>

                <!-- 拖拽排序的图片缩略图列表 -->
                <draggable 
                  v-model="productForm.detailImages" 
                  class="image-gallery-flex" 
                  :options="{ animation: 200 }" 
                  style="margin-top: 20px;"
                >
                  <el-card 
                    v-for="(image, index) in productForm.detailImages" 
                    :key="index" 
                    shadow="hover" 
                    class="image-card">
                    <div class="image-container">
                      <img :src="image" class="image-preview" />
                    </div>
                    <div class="image-actions">
                      <el-button 
                        type="danger" 
                        size="mini" 
                        @click="removeDetailImage(index)">删除</el-button>
                    </div>
                  </el-card>
                </draggable>

                <!-- 图片空间模态框 -->
                <el-dialog title="选择图片" :visible.sync="selectDetailImagesDialogVisible" :width="dialogWidthLarge">
                  <div style="display: flex; align-items: center; margin-bottom: 20px;">
                    <el-dropdown>
                      <el-button type="primary">
                        选择文件夹<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown" style="width: 300px; max-height: 300px; overflow-y: auto;">
                        <el-tree
                          ref="folderTree"
                          :data="folderStructure"
                          node-key="id"
                          :props="{ label: 'label', children: 'children' }"
                          highlight-current
                          @node-click="(folder) => selectFolder(folder, 'detailImages')"
                        />
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>

                  <!-- 图片展示区域 -->
                  <div class="image-gallery-flex">
                    <el-card
                      v-for="(image, index) in imageFiles"
                      :key="index"
                      shadow="hover"
                      class="image-card"
                      @click.native="confirmSelectDetailImage(image)"
                    >
                      <img :src="image.url" class="image-preview-small" />
                      <div class="image-name">{{ image.name }}</div>
                    </el-card>
                  </div>

                  <!-- 【新增】这里也要加分页，否则弹窗里只能看到前20张 -->
                  <div class="pagination-container" style="margin-top: 20px; text-align: center;">
                    <el-pagination
                      small
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      layout="total, prev, pager, next"
                      :total="totalImages">
                    </el-pagination>
                  </div>


                  <span slot="footer" class="dialog-footer">
                    <el-button @click="selectDetailImagesDialogVisible = false">取消</el-button>
                  </span>
                </el-dialog>
              </el-form-item>

              <!-- 新增规格部分 -->
              <h3 class="section-title">规格设置</h3>
              <el-button type="primary" @click="addSpecRow" style="margin-bottom: 10px;">添加规格</el-button>
              
              <draggable 
                v-model="productForm.specs" 
                tag="div" 
                handle=".spec-drag-handle"
                class="spec-draggable-container"
              >
                <div v-for="(spec, index) in productForm.specs" :key="index" class="spec-item">
                  <div class="spec-row">
                    <div class="spec-field">
                      <label>规格名称:</label>
                      <el-input v-model="spec.size_name" placeholder="请输入规格名称"></el-input>
                    </div>
                    
                    <div class="spec-field">
                      <label>规格价格:</label>
                      <el-input v-model="spec.price" type="number" placeholder="请输入价格" @input="updatePriceRange"></el-input>
                    </div>
                    
                    <div class="spec-field spec-image-field">
                      <label>规格图片:</label>
                      <div class="spec-image-container">
                        <img
                          v-if="spec.size_image"
                          :src="spec.size_image"
                          alt="规格图片"
                          class="spec-image"
                          @click="previewImageDialog(spec.size_image)"
                        />
                        <el-button type="primary" size="mini" @click="openImageSelector('specImage', spec)">选择图片</el-button>
                      </div>
                    </div>
                    
                    <div class="spec-actions">
                      <i class="el-icon-rank spec-drag-handle" title="拖拽排序"></i>
                      <el-button
                        type="danger"
                        size="mini"
                        @click="removeSpecRow(index)"
                      >
                        删除
                      </el-button>
                    </div>
                  </div>
                </div>
              </draggable>
              
              <style>
                .spec-draggable-container {
                  width: 100%;
                  margin-bottom: 20px;
                }
                .spec-item {
                  border: 1px solid #ebeef5;
                  margin-bottom: 10px;
                  padding: 15px;
                  border-radius: 4px;
                  background-color: #fff;
                }
                .spec-row {
                  display: flex;
                  flex-wrap: wrap;
                  gap: 15px;
                  align-items: center;
                }
                .spec-field {
                  flex: 1;
                  min-width: 200px;
                }
                .spec-field label {
                  display: block;
                  margin-bottom: 5px;
                  font-weight: bold;
                }
                .spec-image-field {
                  flex: 1.5;
                }
                .spec-actions {
                  display: flex;
                  align-items: center;
                  gap: 10px;
                }
                .spec-drag-handle {
                  cursor: move;
                  font-size: 20px;
                  color: #409EFF;
                  margin-right: 5px;
                }
              </style>
              <!-- 图片选择模态框 -->
              <el-dialog title="选择规格图片" :visible.sync="selectSpecImageDialogVisible" :width="dialogWidthLarge">
                <div style="display: flex; align-items: center; margin-bottom: 20px;">
                  <el-dropdown>
                    <el-button type="primary">
                      选择文件夹<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" style="width: 300px; max-height: 300px; overflow-y: auto;">
                      <el-tree
                        ref="folderTree"
                        :data="folderStructure"
                        node-key="id"
                        :props="{ label: 'label', children: 'children' }"
                        highlight-current
                        @node-click="selectFolder($event, 'specImage')"
                      />
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>

                <!-- 图片展示区域 -->
                <div class="image-gallery-flex">
                  <el-card
                    v-for="(image, index) in imageFiles"
                    :key="index"
                    shadow="hover"
                    class="image-card"
                    @click.native="confirmSelectSpecImage(image)"
                  >
                    <img :src="image.url" class="image-preview-small" />
                    <div class="image-name">{{ image.name }}</div>
                  </el-card>
                </div>

                <!-- 【新增】这里也要加分页，否则弹窗里只能看到前20张 -->
                <div class="pagination-container" style="margin-top: 20px; text-align: center;">
                  <el-pagination
                    small
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="totalImages">
                  </el-pagination>
                </div>

                <span slot="footer" class="dialog-footer">
                  <el-button @click="selectSpecImageDialogVisible = false">取消</el-button>
                </span>
              </el-dialog>
              <!-- 预览规格图片 -->
              <el-dialog
                :visible.sync="previewVisible"
                :width="dialogWidthLarge"
                class="preview-dialog"
                :show-close="true"
                custom-class="custom-dialog"
              >
                <img :src="previewImage" class="preview-image" alt="预览图片" />
              </el-dialog>
            </el-form>

            <div class="button-container">
              <el-button type="primary" @click="saveProduct">保存</el-button>
              <el-button @click="cancelProductSettings">取消</el-button>
            </div>
          </div>

          <!-- 图片选择模态框 -->
          <el-dialog title="选择图片" :visible.sync="selectImageDialogVisible" :width="dialogWidthLarge">
            <div style="display: flex; align-items: center; margin-bottom: 20px;">
              <el-dropdown>
                <el-button type="primary">
                  选择文件夹<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" style="width: 300px; max-height: 300px; overflow-y: auto;">
                  <el-tree
                    ref="folderTree"
                    :data="folderStructure"
                    node-key="id"
                    :props="{ label: 'label', children: 'children' }"
                    highlight-current
                    @node-click="(folder) => selectFolder(folder, 'Images')"
                  />
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <!-- 图片展示区域 -->
            <div class="image-gallery-flex">
              <el-card
                v-for="(image, index) in imageFiles"
                :key="index"
                shadow="hover"
                class="image-card"
                @click.native="confirmSelectImage(image)"
              >
                <img :src="image.url" class="image-preview-small" />
                <div class="image-name">{{ image.name }}</div>
              </el-card>
            </div>

            <!-- 【新增】这里也要加分页，否则弹窗里只能看到前20张 -->
            <div class="pagination-container" style="margin-top: 20px; text-align: center;">
              <el-pagination
                small
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="totalImages">
              </el-pagination>
            </div>


            <span slot="footer" class="dialog-footer">
              <el-button @click="selectImageDialogVisible = false">取消</el-button>
            </span>
          </el-dialog>

          <el-dialog title="重命名图片" :visible.sync="renameDialogVisible" :width="dialogWidthSmall">
            <el-form>
              <el-form-item label="新名称">
                <el-input v-model="newImageName" placeholder="请输入新的文件名" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="renameDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="confirmRename">确认</el-button>
            </span>
          </el-dialog>

          <div v-if="activeMenu === '5'">
            <h2>个人中心</h2>
            <el-card class="user-info-card">
              <div>
                <span>用户名：</span>{{ userInfo.username }}
              </div>
              <!-- <div>
                <span>邮箱：</span>{{ userInfo.email }}
              </div> -->
              <div>
                <span>有效期：</span>{{ expirationDate }}
              </div>
            </el-card>
            <el-button type="warning" @click="openResetUsernameDialog">重置用户名</el-button>
            <el-button type="warning" @click="openResetPasswordDialog">重置密码</el-button>

            <!-- 重置用户名模态框 -->
            <el-dialog title="重置用户名" :visible.sync="resetUsernameDialogVisible" :width="dialogWidthSmall">
              <el-form ref="resetUsernameForm" :model="resetUsernameForm" :rules="resetUsernameRules">
                <el-form-item label="新用户名" prop="newUsername">
                  <el-input v-model="resetUsernameForm.newUsername" placeholder="请输入新用户名"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="resetUsernameDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleResetUsername">确认</el-button>
              </div>
            </el-dialog>

            <!-- 重置密码模态框 -->
            <el-dialog title="重置密码" :visible.sync="resetPasswordDialogVisible" :width="dialogWidthSmall">
              <el-form ref="resetPasswordForm" :model="resetPasswordForm" :rules="resetPasswordRules">
                <el-form-item label="当前密码" prop="currentPassword">
                  <el-input v-model="resetPasswordForm.currentPassword" type="password" placeholder="请输入当前密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                  <el-input v-model="resetPasswordForm.newPassword" type="password" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" prop="confirmNewPassword">
                  <el-input v-model="resetPasswordForm.confirmNewPassword" type="password" placeholder="请再次输入新密码"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="resetPasswordDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleResetPassword">确认</el-button>
              </div>
            </el-dialog>
          </div>

          <div v-if="activeMenu === '6'">
            <h2>首页图片设置</h2>
            <el-form>
              <el-form-item label="首页上方图">
                <div class="image-selector" @click="openhomeImageSelector('HomeTopImage')">
                  <img 
                    v-if="homeTopImage" 
                    :src="homeTopImage" 
                    alt="首页上方图" 
                    class="image-preview_add"
                    @error="handleImageError"
                  />
                  <i v-else class="el-icon-plus image-placeholder-icon"></i>
                </div>
              </el-form-item>

              <el-form-item label="首页下方滚动图">
                <!-- 上传按钮和提示 -->
                <div class="upload-section">
                  <el-button type="primary" @click="openhomeImageSelector('HomeScrollingImages')" class="upload-button">点击上传</el-button>
                  <span class="upload-tip" style="color: red; margin-left: 10px;">(拖动图片可调整顺序，最多可选择 5 张图片)</span>
                </div>

                <!-- 拖拽排序的图片缩略图列表 -->
                <draggable 
                  v-model="homeScrollingImages" 
                  class="image-gallery-flex" 
                  :options="{ animation: 200 }" 
                  style="margin-top: 20px;"
                >
                  <el-card 
                    v-for="(image, index) in homeScrollingImages" 
                    :key="index" 
                    shadow="hover" 
                    class="image-card">
                    <div class="image-container">
                      <img :src="image" class="image-preview" />
                    </div>
                    <div class="image-actions">
                      <el-button 
                        type="danger" 
                        size="mini" 
                        @click="removeHomeScrollingImage(index)">删除</el-button>
                    </div>
                  </el-card>
                </draggable>

                <!-- 图片空间模态框 -->
                <el-dialog title="选择图片" :visible.sync="selectHomeScrollingImagesDialogVisible" :width="dialogWidthLarge">
                  <div style="display: flex; align-items: center; margin-bottom: 20px;">
                    <el-dropdown>
                      <el-button type="primary">
                        选择文件夹<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown" style="width: 300px; max-height: 300px; overflow-y: auto;">
                        <el-tree
                          ref="folderTree"
                          :data="folderStructure"
                          node-key="id"
                          :props="{ label: 'label', children: 'children' }"
                          highlight-current
                          @node-click="(folder) => selecthomeFolder(folder, 'HomeScrollingImages')"
                        />
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>

                  <!-- 图片展示区域 -->
                  <div class="image-gallery-flex">
                    <el-card
                      v-for="(image, index) in imageFiles" 
                      :key="index"
                      shadow="hover"
                      class="image-card"
                      @click.native="confirmSelectHomeScrollingImage(image)"
                    >
                      <img :src="image.url" class="image-preview-small" />
                      <div class="image-name">{{ image.name }}</div>
                    </el-card>
                  </div>

                  <!-- 【新增】这里也要加分页，否则弹窗里只能看到前20张 -->
                  <div class="pagination-container" style="margin-top: 20px; text-align: center;">
                    <el-pagination
                      small
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      layout="total, prev, pager, next"
                      :total="totalImages">
                    </el-pagination>
                  </div>


                  <span slot="footer" class="dialog-footer">
                    <el-button @click="selectHomeScrollingImagesDialogVisible = false">取消</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="选择图片" :visible.sync="selectImageDialogVisible" :width="dialogWidthLarge">
                  <div style="display: flex; align-items: center; margin-bottom: 20px;">
                    <el-dropdown>
                      <el-button type="primary">
                        选择文件夹<i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown" style="width: 300px; max-height: 300px; overflow-y: auto;">
                        <el-tree
                          ref="folderTree"
                          :data="folderStructure"
                          node-key="id"
                          :props="{ label: 'label', children: 'children' }"
                          highlight-current
                          @node-click="(folder) => selecthomeFolder(folder, 'HomeTopImage')"
                        />
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>

                  <!-- 图片展示区域 -->
                  <div class="image-gallery-flex">
                    <el-card
                      v-for="(image, index) in imageFiles"
                      :key="index"
                      shadow="hover"
                      class="image-card"
                      @click.native="confirmSelectHomeTopImage(image)"
                    >
                      <img :src="image.url" class="image-preview-small" />
                      <div class="image-name">{{ image.name }}</div>
                    </el-card>
                  </div>

                  <!-- 【新增】这里也要加分页，否则弹窗里只能看到前20张 -->
                  <div class="pagination-container" style="margin-top: 20px; text-align: center;">
                    <el-pagination
                      small
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="pageSize"
                      layout="total, prev, pager, next"
                      :total="totalImages">
                    </el-pagination>
                  </div>


                  <span slot="footer" class="dialog-footer">
                    <el-button @click="selectImageDialogVisible = false">取消</el-button>
                  </span>
                </el-dialog>
              </el-form-item>
            </el-form>
            <div class="button-container">
              <el-button type="primary" @click="saveHomePageImages">保存</el-button>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import axios from 'axios';
import { Loading } from 'element-ui';

export default {
  name: "AdminPanel",
  components: { draggable },
  data() {
    return {
      activeMenu: "1",
      selectAll: false,
      categories: [],
      selectedFolder: "",
      folderStructure: [],
      dialogVisible: false,
      newCategoryName: "",
      confirmDeleteDialogVisible: false,
      categoryToDelete: null,
      loadingInstance: null,
      MIN_LOADING_TIME: 1000, // 最小加载时间
      createFolderDialogVisible: false,
      newFolderName: "",
      defaultProps: {
        label: "label",
        children: "children"
      },
      imageFiles: [], // 新增：存储图片文件的路径
      renameDialogVisible: false, // 重命名对话框可见性
      currentImageIndex: null, // 当前重命名的图片索引
      currentImagePath: "", // 当前重命名的图片路径
      newImageName: "", // 新的图片名称
      usedSpaceMB: 0,      // 已用空间（MB）
      // maxSpace: 512,     // 最大允许空间（MB）
      maxSpace: 0,  // 动态图片空间大小
      selectedCategory: null,
      products: [], // 用于存储筛选后的商品
      categories: [],
      productSettingsMode: "", // 区分添加或编辑模式
      productForm: { id: null, image: '', name: '', detailMainImages: [], detailImages: [], specs: [], min_price: null, max_price: null, category_id: null}, // 商品信息
      selectImageDialogVisible: false, // 控制选择图片对话框
      isFolderDialogVisible: false, // 控制文件夹选择对话框
      defaultImage: 'path_to_default_image.jpg', // 默认图片路径
      selectDetailMainImagesDialogVisible: false, // 控制模态框显示状态
      selectDetailImagesDialogVisible: false, // 控制详情页详情图的模态框
      selectedSpec: null, // 当前选中的规格行
      selectSpecImageDialogVisible: false, // 新增：规格图片模态框可见性
      previewVisible: false, // 控制图片预览弹窗
      previewImage: "", // 当前预览的图片 URL
      userInfo: {
        username: "", // 默认值
        email: "",    // 默认值
      },
      resetPasswordDialogVisible: false,
      resetPasswordForm: {
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: ""
      },
      resetPasswordRules: {
        currentPassword: [{ required: true, message: "请输入当前密码", trigger: "blur" }],
        newPassword: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        confirmNewPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.resetPasswordForm.newPassword) {
                callback(new Error("两次输入的新密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      resetUsernameDialogVisible: false,
      resetUsernameForm: {
        newUsername: ""
      },
      resetUsernameRules: {
        newUsername: [{ required: true, message: "请输入新用户名", trigger: "blur" }]
      },
      homeTopImage: '',
      homeScrollingImages: [],
      selectHomeScrollingImagesDialogVisible: false,
      expirationDate: null,
      editCategoryDialogVisible: false,
      editCategoryName: "",
      currentEditCategoryId: null, // 添加当前正在编辑的类目ID
      // 【251204新增】：记录当前所在的文件夹ID，默认 0 表示根目录
      currentFolderId: 0, 
      selectedFolder: "根目录", 
      // 【251205新增】用于存当前要重命名的图片ID
      currentImageId: null, 
      // 【251205新增】分页相关变量
      currentPage: 1,      // 当前页码
      pageSize: 20,        // 每页显示多少条
      totalImages: 0,      // 总图片数
      isMobile: false, // 是否为移动端
      isSidebarOpen: false, // 移动端侧边栏是否打开
    };
  },
  created() {
    const imageSpaceSize = localStorage.getItem('image_space_size');
    if (imageSpaceSize) {
      this.maxSpace = parseInt(imageSpaceSize);  // 从本地存储中读取图片空间大小
    }
  },
  methods: {
    handleSelect(index) {
      this.activeMenu = index;
      if (index === "1") {
        this.fetchCategories();
      } else if (index === "2") {
        this.fetchFolderStructure();
      } else if (index === "3") {
        this.fetchCategories(); // 进入商品设置时加载类目
      } else if (index === "5") {
        this.fetchUserInfo(); // 获取用户信息
      }else if (index === "6") {
        // 处理首页图片设置菜单项的选择事件
        // 例如，加载首页图片设置页面的数据
        this.fetchHomePageImages();
      }
    },

    handleImageError() {
      this.$message.error('图片加载失败，请检查图片路径或网络连接');
    },

    // 1. 添加窗口大小监听处理
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.isSidebarOpen = false; // PC端重置状态
      }
    },
    
    // 2. 切换侧边栏方法
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },

    // 新增获取首页图片数据的方法
    async fetchHomePageImages() {
      try {
        const response = await axios.get('https://www.xinzhilian.top/product_flask/get_home_page_images');
        this.homeTopImage = response.data.topImage;
        this.homeScrollingImages = response.data.scrollingImages;
      } catch (error) {
        console.error('获取首页图片数据失败:', error);
      }
    },
    // 新增保存首页图片数据的方法
    async saveHomePageImages() {
      try {
        const data = {
          topImage: this.homeTopImage,
          scrollingImages: this.homeScrollingImages
        };
        await axios.post('https://www.xinzhilian.top/product_flask/save_home_page_images', data);
        this.$message.success("首页图片设置保存成功");
      } catch (error) {
        console.error('保存首页图片数据失败:', error);
        this.$message.error("首页图片设置保存失败");
      }
    },
    // 打开图片选择器
    openhomeImageSelector(dialogType) {
      this.fetchFolderStructure();
      if (dialogType === 'HomeTopImage') {
        this.selectImageDialogVisible = true;
      } else if (dialogType === 'HomeScrollingImages') {
        this.selectHomeScrollingImagesDialogVisible = true;
      }
    },
    selecthomeFolder(folder, dialogType) {
      // 【修改核心 1】：记录当前点击的文件夹 ID
      this.currentFolderId = folder.id;
      
      // 【修改核心 2】：更新显示的名称
      this.selectedFolder = folder.label;
      
      // 【新增这一行】切换文件夹时，必须回到第一页
      this.currentPage = 1; 

      // 获取图片
      this.fetchImagesInFolder();
      
      // 保持弹窗显示
      if (dialogType === 'HomeTopImage') {
        this.selectImageDialogVisible = true;
      } else if (dialogType === 'HomeScrollingImages') {
        this.selectHomeScrollingImagesDialogVisible = true;
      }
    },
    confirmSelectHomeTopImage(imageUrl) {
      // console.log('选择的图片 URL:', imageUrl); // 打印选择的图片 URL 进行调试
      this.homeTopImage = imageUrl.url; // 更新 homeTopImage
      this.selectImageDialogVisible = false; // 关闭选择图片对话框
    },
    confirmSelectHomeScrollingImage(image) {
      // console.log('选择的图片 URL:', image);
      if (this.homeScrollingImages.length >= 5) {
        this.$message.warning("最多可选择 5 张图片");
        return;
      }
      this.homeScrollingImages.push(image.url);
      this.selectHomeScrollingImagesDialogVisible = false;
    },
    removeHomeScrollingImage(index) {
      this.homeScrollingImages.splice(index, 1);
    },

    openResetUsernameDialog() {
      this.resetUsernameDialogVisible = true;
    },
    async handleResetUsername() {
      this.$refs.resetUsernameForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error("请完成表单填写");
          return;
        }

        const { newUsername } = this.resetUsernameForm;

        try {
          const response = await axios.post(
            "https://www.xinzhilian.top/product_flask/reset_username",
            {
              new_username: newUsername
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwt_token")}`
              }
            }
          );

          this.$message.success("用户名重置成功");
          this.resetUsernameDialogVisible = false;
          this.resetUsernameForm = { newUsername: "" };
          this.fetchUserInfo(); // 刷新用户信息
        } catch (error) {
          console.error("用户名重置失败:", error);
          this.$message.error(error.response?.data?.error || "用户名重置失败，请稍后重试");
        }
      });
    },

    openResetPasswordDialog() {
      this.resetPasswordDialogVisible = true;
    },
    handleResetPassword() {
      this.$refs.resetPasswordForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error("请完成表单填写");
          return;
        }

        const { currentPassword, newPassword } = this.resetPasswordForm;
        // console.log("currentPassword",currentPassword);
        // console.log("newPassword",newPassword);

        try {
          const response = await axios.post(
            "https://www.xinzhilian.top/product_flask/reset_password",
            {
              current_password: currentPassword,
              new_password: newPassword
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwt_token")}`
              }
            }
          );

          this.$message.success("密码重置成功");
          this.resetPasswordDialogVisible = false;
          this.resetPasswordForm = { currentPassword: "", newPassword: "", confirmNewPassword: "" };
        } catch (error) {
          console.error("密码重置失败:", error);
          this.$message.error(error.response?.data?.error || "密码重置失败，请稍后重试");
        }
      });
    },

    async fetchUserInfo() {
      try {
        const response = await axios.get('https://www.xinzhilian.top/product_flask/get_user_info', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('jwt_token')}`
          }
        });
        const userData = response.data;

        // 假设返回的数据包含用户名和邮箱
        this.userInfo = {
          username: userData.username,
          email: userData.email,
        };
        this.expirationDate = userData.expiration_date;

        if (this.expirationDate) {
          const today = new Date();
          const expiration = new Date(this.expirationDate);
          const diffTime = Math.abs(expiration - today);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          if (diffDays <= 15) {
              this.$alert(`账号有效期还剩 ${diffDays} 天，请及时续费！`, '提示', {
                  confirmButtonText: '确定',
              });
          }
        }

        // 切换到"个人中心"页面
        this.activeMenu = "5";
      } catch (error) {
        console.error("获取用户信息失败:", error);
        this.$message.error("获取用户信息失败");
      }
    },

    // 上移
    moveProductUp(index) {
      if (index > 0) {
        const item = this.products[index];
        this.products.splice(index, 1);
        this.products.splice(index - 1, 0, item);
        this.updateProductSortOrder();
      }
    },
    // 下移
    moveProductDown(index) {
      if (index < this.products.length - 1) {
        const item = this.products[index];
        this.products.splice(index, 1);
        this.products.splice(index + 1, 0, item);
        this.updateProductSortOrder();
      }
    },
    // 置顶
    moveProductToTop(index) {
      if (index > 0) {
        const item = this.products.splice(index, 1)[0];
        this.products.unshift(item);
        this.updateProductSortOrder();
      }
    },
    // 置底
    moveProductToBottom(index) {
      if (index < this.products.length - 1) {
        const item = this.products.splice(index, 1)[0];
        this.products.push(item);
        this.updateProductSortOrder();
      }
    },
    updateProductSortOrder() {
      const sortedProducts = this.products.map((product, index) => ({
        id: product.id,
        sort_order: index + 1, // 新的排序值
      }));

      axios
        .post('https://www.xinzhilian.top/product_flask/update_product_sort_order', {
          category_id: this.selectedCategory,
          products: sortedProducts,
        })
        .then(() => {
          this.$message.success("排序更新成功");
          this.fetchProducts(); // 刷新商品列表
        })
        .catch((error) => {
          console.error("排序更新失败:", error);
          this.$message.error("排序更新失败");
        });
    },


    async editProduct(productId) {
      try {
        // 调用后端 API 获取商品详情数据
        const response = await axios.get(`https://www.xinzhilian.top/product_flask/get_product_details/${productId}`);
        const data = response.data;

        // 更新表单数据
        this.productForm = {
          id: data.id,
          category_id: data.category_id,         // 从 products 表
          name: data.name,                      // 从 products 表
          image: data.image,                    // 从 products 表
          detailMainImages: data.main_images,   // 从 product_images 表
          detailImages: data.detail_images,     // 从 product_images 表
          specs: data.specifications,           // 从 product_sizes 表
          min_price: data.min_price,            // 从 product_sizes 表
          max_price: data.max_price             // 从 product_sizes 表
        };

        // 切换视图到编辑模式
        this.productSettingsMode = "edit";
        this.activeMenu = "4";
      } catch (error) {
        console.error("获取商品详情失败:", error);
        this.$message.error("加载商品详情失败");
      }
    },

    // 上移
    moveSpecUp(index) {
      // console.log("上移")
      if (index > 0) {
        const specs = this.productForm.specs;
        const item = specs[index];
        specs.splice(index, 1); // 删除当前项
        specs.splice(index - 1, 0, item); // 插入到前一个位置
        this.$set(this.productForm, 'specs', [...specs]); // 触发视图更新
      }
    },
    // 下移
    moveSpecDown(index) {
      // console.log("下移")
      if (index < this.productForm.specs.length - 1) {
        const specs = this.productForm.specs;
        const item = specs[index];
        specs.splice(index, 1); // 删除当前项
        specs.splice(index + 1, 0, item); // 插入到后一个位置
        this.$set(this.productForm, 'specs', [...specs]); // 触发视图更新
      }
    },
    // 置顶
    moveSpecToTop(index) {
      if (index > 0) {
        const specs = this.productForm.specs;
        const [item] = specs.splice(index, 1);
        specs.unshift(item);
      }
    },
    // 置底
    moveSpecToBottom(index) {
      if (index < this.productForm.specs.length - 1) {
        const specs = this.productForm.specs;
        const [item] = specs.splice(index, 1);
        specs.push(item);
      }
    },

    updatePriceRange() {
    if (this.productForm.specs.length === 0) {
      this.productForm.min_price = null;
      this.productForm.max_price = null;
      return;
    }
    // 提取所有有效的价格
    const prices = this.productForm.specs
      .map(spec => parseFloat(spec.price))
      .filter(price => !isNaN(price));
    // 计算最小值和最大值
    this.productForm.min_price = Math.min(...prices);
    this.productForm.max_price = Math.max(...prices);
  },

    // 添加规格行
    addSpecRow() {
      this.productForm.specs.push({ size_name: '', price: '', size_image: '' });
      this.updatePriceRange(); // 更新价格范围
    },

    // 删除规格行
    removeSpecRow(index) {
      this.productForm.specs.splice(index, 1);
      this.updatePriceRange(); // 更新价格范围
    },

    // 确认选择规格图片
    confirmSelectSpecImage(imageObj) { // 建议把参数名改成 imageObj 以免混淆
      if (this.selectedSpec) {
        // 【修改点】：取 .url 赋值给规格图片字段
        this.selectedSpec.size_image = imageObj.url; 
        
        this.selectedSpec = null; // 清空选中状态
      }
      this.selectSpecImageDialogVisible = false; // 关闭模态框
    },

    previewImageDialog(imageUrl) {
    this.previewImage = imageUrl; // 设置要预览的图片 URL
    this.previewVisible = true; // 打开预览对话框
  },


    // 确认选择详情页详情图
    confirmSelectDetailImage(image) {
      // console.log("Selected Image:", image);
      // console.log("Current productForm.detailImages:", this.productForm.detailImages);
      this.productForm.detailImages.push(image.url);
      this.selectDetailImagesDialogVisible = false;
    },

    // 删除详情页详情图
    removeDetailImage(index) {
      this.productForm.detailImages.splice(index, 1);
    },

    // 确认选择图片
    confirmSelectDetailMainImage(image) {
      if (this.productForm.detailMainImages.length >= 5) {
        this.$message.warning("最多可选择 5 张图片");
        return;
      }
      this.productForm.detailMainImages.push(image.url);
      // console.log("this.productForm.detailMainImages",this.productForm.detailMainImages)
      this.selectDetailMainImagesDialogVisible = false;
    },

    // 移除图片
    removeDetailMainImage(index) {
      this.productForm.detailMainImages.splice(index, 1);
    },
    openAddProduct() {
      this.productSettingsMode = 'add';
      this.productForm = { id: null, image: '', name: '', detailMainImages: [], detailImages: [], specs: [], min_price: null, max_price: null, category_id: null};
      this.activeMenu = "4";
    },
    // 打开文件夹选择对话框
    openImageSelector(dialogType, spec = null) {
      if (dialogType === 'specImage') {
        this.selectedSpec = spec; 
      }
      
      // 1. 获取文件夹树
      this.fetchFolderStructure();
      
      // 2. 【建议新增】打开弹窗时，默认加载当前 ID 对应的图片
      // 如果你想每次打开都回到根目录，可以在这里加一句: this.currentFolderId = 0;
      this.fetchImagesInFolder(); 

      if (dialogType === 'detailMainImages') {
        this.selectDetailMainImagesDialogVisible = true;
      } else if (dialogType === 'detailImages') {
        this.selectDetailImagesDialogVisible = true;
      } else if (dialogType === 'specImage') {
        this.selectSpecImageDialogVisible = true; 
      } else {
        this.selectImageDialogVisible = true;
      }
    },
    // 选择文件夹后加载该文件夹的图片
    selectFolder(folder, dialogType) {
      // 【修改核心 1】：记录当前点击的文件夹 ID
      this.currentFolderId = folder.id;
      
      // 【修改核心 2】：更新显示的名称（仅用于界面展示）
      this.selectedFolder = folder.label; 

      // 【新增这一行】切换文件夹时，必须回到第一页
      this.currentPage = 1; 
      
      // 调用获取图片接口（它会读取 this.currentFolderId）
      this.fetchImagesInFolder();

      // 下面的逻辑保持不变，用于维持弹窗的显示状态
      if (dialogType === 'detailMainImages') {
        this.selectDetailMainImagesDialogVisible = true;
      } else if (dialogType === 'detailImages') {
        this.selectDetailImagesDialogVisible = true;
      } else if (dialogType === 'specImage') {
        this.selectSpecImageDialogVisible = true; 
      } else {
        this.selectImageDialogVisible = true;
      }
    },

    // 确认选择图片
    // confirmSelectImage(imageUrl) {
    //   this.productForm.image = imageUrl; // 设置商品图片字段
    //   this.selectImageDialogVisible = false;
    // },
    confirmSelectImage(imageObj) {
      // imageObj 是 {id:..., url:..., name:...}
      // 我们只需要 url 存到商品表单里
      this.productForm.image = imageObj.url; 
      this.selectImageDialogVisible = false;
    },

    // 保存商品方法
    async saveProduct() {
      // console.log("保存商品数据:", this.productForm);

      // 表单验证
      if (!this.validateForm()) {
        this.$message.error("请完成所有内容填写");
        return;
      }

      // console.log("表单验证通过，保存商品数据:", this.productForm);

      const isUpdate = !!this.productForm.id; // 判断是否是更新操作

      // 准备要发送的数据
      const productData = {
        id: this.productForm.id, // 如果是更新，后端会使用此 ID 区分
        name: this.productForm.name,
        category_id: this.productForm.category_id,
        image: this.productForm.image,
        price: this.productForm.min_price, // 写入 products 表的 price 字段
        min_price: this.productForm.min_price, // 写入 product_sizes 表的 min_price
        max_price: this.productForm.max_price, // 写入 product_sizes 表的 max_price
        main_images: this.productForm.detailMainImages, // 写入 product_images 表
        detail_images: this.productForm.detailImages, // 写入 product_images 表
        specifications: this.productForm.specs, // 直接作为 JSON 写入 product_sizes 表
      };

      // 根据操作类型调用不同的 API
      const apiUrl = isUpdate
        ? `https://www.xinzhilian.top/product_flask/update_product`
        : `https://www.xinzhilian.top/product_flask/add_product`;

      axios
        .post(apiUrl, productData)
        .then(() => {
          this.$message.success(isUpdate ? "商品更新成功" : "商品添加成功");
          this.activeMenu = "3"; // 返回商品列表视图
          this.fetchProducts(); // 刷新商品列表
        })
        .catch((error) => {
          console.error("保存商品数据失败:", error);
          this.$message.error(isUpdate ? "商品更新失败" : "商品添加失败");
        });
    },

    // 表单验证方法
    validateForm() {
      // 验证主表单内容
      const { image, name, category_id, specs } = this.productForm;
      if (!image || !name || !category_id) {
        return false; // 如果主表单内容缺失，验证不通过
      }

      // 检查规格内容是否为空
      if (!specs || specs.length === 0) {
        return false; // 如果没有规格，验证不通过
      }

      // 验证规格内容
      for (let i = 0; i < specs.length; i++) {
        const { size_name, price, size_image } = specs[i];
        if (!size_name || !price || !size_image) {
          return false; // 如果任意规格内容缺失，验证不通过
        }
      }

      return true; // 所有验证通过
    },

    cancelProductSettings() {
      this.activeMenu = "3";
    },
    async fetchProducts() {
      // 显示加载中，设置加载信息
      this.showLoading('加载中...');
      const startTime = Date.now();
      try {
          const response = await axios.get(`https://www.xinzhilian.top/product_flask/get_products?category_id=${this.selectedCategory}`);
          // 给每个商品对象添加 checked 属性，并初始化为 false
          this.products = response.data.map(product => ({
              ...product,
              checked: false
          }));
      } catch (error) {
          console.error("获取商品数据失败:", error);
      } finally {
          const elapsed = Date.now() - startTime;
          const remaining = 1000 - elapsed;
          setTimeout(() => {
              this.hideLoading();
          }, remaining > 0 ? remaining : 0);
      }
    },
    // 全选/全不选处理方法
    handleSelectAll() {
        this.products.forEach(product => {
            product.checked = this.selectAll;
        });
    },
    // 确认批量删除方法
    confirmBatchDelete() {
        const selectedProducts = this.products.filter(product => product.checked);
        if (selectedProducts.length === 0) {
            this.$message.warning("请选择要删除的商品");
            return;
        }
        this.$confirm('确定要删除选中的商品吗？', '删除确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            const productIds = selectedProducts.map(product => product.id);
            this.batchDeleteProducts(productIds);
        }).catch(() => {
            this.$message.info("删除已取消");
        });
    },
    // 批量删除商品方法
    async batchDeleteProducts(productIds) {
        try {
            await axios.post('https://www.xinzhilian.top/product_flask/batch_delete_products', { productIds });
            this.$message.success("商品批量删除成功");
            this.fetchProducts(); // 刷新商品列表
        } catch (error) {
            this.$message.error("批量删除商品失败");
        }
    },
    // 弹出删除确认对话框
    confirmDeleteProduct(productId) {
        this.$confirm('确定要删除此商品吗？', '删除确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            // 用户点击"确定"按钮后，调用删除商品的方法
            this.deleteProduct(productId);
        }).catch(() => {
            this.$message.info("删除已取消");
        });
    },
    // 删除商品方法，调用后端路由
    async deleteProduct(productId) {
        try {
            await axios.delete(`https://www.xinzhilian.top/product_flask/delete_product/${productId}`);
            this.$message.success("商品删除成功");
            this.fetchProducts(); // 刷新商品列表
        } catch (error) {
            this.$message.error("删除商品失败");
        }
    },
    async getFolderSize() {
      try {
        const response = await axios.post('https://www.xinzhilian.top/product_flask/get_folder_size', {
          database_name: localStorage.getItem('database_name')
        });
        
        if (response.data.usedSpaceMB !== undefined) {
          // 【修改点】加上 parseFloat，防止是字符串
          this.usedSpaceMB = parseFloat(response.data.usedSpaceMB);
        }
      } catch (error) {
        console.error("获取大小失败", error); // 调试用
        // this.$message.error("获取文件夹大小失败"); // 可选：不仅提示，保持 usedSpaceMB 为 0 也行
      }
    },
    // 触发文件选择
    triggerFileUpload() {
      if (!this.selectedFolder) {
        this.$message.warning("请先选择要上传的文件夹");
        return;
      }
      this.$refs.fileInput.click();
    },
    // 处理文件上传
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // 预判大小 (MB)
      const fileSizeMB = file.size / (1024 * 1024); 

      // 如果加上这张图会超限，直接拦截
      // if (this.usedSpaceMB + fileSizeMB > this.maxSpace) {
      //   this.$message.error(`上传失败：空间不足 (剩余 ${(this.maxSpace - this.usedSpaceMB).toFixed(2)} MB)`);
      //   event.target.value = null; // 清空 input
      //   return;
      // }
      if (this.usedSpaceMB + fileSizeMB > this.maxSpace) {
        // 计算剩余空间 (MB)
        const remainingMB = this.maxSpace - this.usedSpaceMB;
        // 转换为 GB 显示
        const maxGB = (this.maxSpace / 1024).toFixed(2);
        const remainingGB = (remainingMB / 1024).toFixed(2);

        this.$message.error(`上传失败：空间不足 (总限额 ${maxGB} GB，剩余 ${remainingGB} GB)`);
        return;
      }

      const formData = new FormData();
      formData.append('database_name', localStorage.getItem('database_name'));
      formData.append('folder_id', this.currentFolderId || 0);
      formData.append('file', file);

      try {
          await this.runWithMinLoading(async () => {
              const response = await axios.post('https://www.xinzhilian.top/product_flask/upload_image', formData, {
                  headers: { 'Content-Type': 'multipart/form-data' }
              });

              if (response.data.success) {
                  this.$message.success("图片上传成功");
                  this.imageFiles.push(response.data.image);
                  
                  // 【修改点】直接累加后端返回的原始大小(MB)
                  // 以前是加 compressedSize，现在加 originalSize
                  const addedMB = parseFloat(response.data.originalSizeMB || 0);
                  this.usedSpaceMB += addedMB;
                  
              } else {
                  this.$message.error(response.data.error || "上传失败");
              }
          }, "上传中...");
      } catch (error) {
          this.$message.error(error.response?.data?.error || "图片上传失败");
      } finally {
        event.target.value = null;
      }
    },
    renameImage(index, image) {
      // image 现在是对象 {id, url, name}
      this.currentImageIndex = index;
      
      // 【修改点】：保存 ID 和 Name
      this.currentImageId = image.id; 
      this.newImageName = image.name; 
      
      this.renameDialogVisible = true;
    },
    async confirmRename() {
      if (!this.newImageName.trim()) {
          this.$message.error("文件名不能为空");
          return;
      }

      this.showLoading("处理中...");
      
      try {
          const response = await axios.post('https://www.xinzhilian.top/product_flask/rename_image', {
              // 【修改点】：传 ID
              image_id: this.currentImageId,
              new_name: this.newImageName,
          }, {
            headers: { Authorization: `Bearer ${localStorage.getItem('jwt_token')}` }
          });
          
          this.hideLoading();
          
          if (response.data.success) {
              this.$message.success("重命名成功");
              
              // 【修改点】：直接更新本地数组显示的名称，不需要刷新列表
              // 注意：这里必须用 this.$set 或者直接赋值对象的属性，Vue才能监听到变化
              this.imageFiles[this.currentImageIndex].name = this.newImageName;
              
              this.renameDialogVisible = false;
          } else {
              this.$message.error(response.data.error || "重命名失败");
          }
      } catch (error) {
          this.hideLoading();
          this.$message.error(error.response?.data?.error || "重命名失败");
      }
    },

    async deleteImage(index, image) {
      // image: { id, url, name, size_bytes }
      this.$confirm('确定要删除此图片吗？', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(async () => {
          this.showLoading("处理中...");
          try {
              await axios.post(
                  'https://www.xinzhilian.top/product_flask/delete_image', 
                  { image_id: image.id },
                  { headers: { Authorization: `Bearer ${localStorage.getItem('jwt_token')}` } }
              );
              
              this.hideLoading();
              this.$message.success("图片删除成功");
              
              this.imageFiles.splice(index, 1);
              
              // 【修改点】根据图片记录的原始大小进行减法
              if (image.size_bytes) {
                const deletedMB = parseFloat(image.size_bytes) / (1024 * 1024);
                this.usedSpaceMB -= deletedMB;
                
                // 防止精度问题出现 -0.00001 这种情况
                if (this.usedSpaceMB < 0) this.usedSpaceMB = 0;
              } else {
                  // 如果是旧数据没有 size_bytes，就重新拉一次总数，保险
                  this.getFolderSize();
              }
              
          } catch (error) {
              this.hideLoading();
              this.$message.error(error.response?.data?.error || "图片删除失败");
          }
      }).catch(() => {
          this.$message.info("删除已取消");
      });
    },
    async fetchCategories() {
      try {
        const response = await axios.get('https://www.xinzhilian.top/product_flask/get_categories', { withCredentials: true });
        this.categories = response.data;
      } catch (error) {
        console.error("获取类目数据失败:", error);
      }
    },
    openDialog() {
      this.dialogVisible = true;
      this.newCategoryName = "";
    },
    async addCategory() {
      if (!this.newCategoryName.trim()) {
        this.$message.error("类目名称不能为空");
        return;
      }
      try {
        await axios.post('https://www.xinzhilian.top/product_flask/add_category', { name: this.newCategoryName }, { withCredentials: true });
        this.$message.success("类目添加成功");
        this.dialogVisible = false;
        this.fetchCategories();
      } catch (error) {
        this.$message.error(error.response?.data?.error || "添加类目失败");
      }
    },
    showDeleteConfirm(categoryId) {
      this.categoryToDelete = categoryId;
      this.confirmDeleteDialogVisible = true;
    },
    async confirmDelete() {
      try {
        await this.runWithMinLoading(async () => {
          await axios.delete(`https://www.xinzhilian.top/product_flask/delete_category/${this.categoryToDelete}`, { withCredentials: true });
          this.$message.success("类目删除成功");
          this.confirmDeleteDialogVisible = false;
          await this.fetchCategories();
        }, "处理中...");
      } catch (error) {
        if (error.response) {
            // 服务器返回了错误响应
            const errorMessage = error.response.data.error || "删除类目失败，请稍后重试";
            this.$message.error(errorMessage);
        } else if (error.request) {
            // 请求已发送，但没有收到响应
            this.$message.error("没有收到服务器响应，请检查网络连接");
        } else {
            // 在设置请求时发生错误
            this.$message.error("请求设置出错，请检查代码");
        }
      }
    },

    moveUp(index) {
      if (index > 0) {
        [this.categories[index - 1], this.categories[index]] = [this.categories[index], this.categories[index - 1]];
        this.updateSortOrder();
      }
    },
    moveDown(index) {
      if (index < this.categories.length - 1) {
        [this.categories[index], this.categories[index + 1]] = [this.categories[index + 1], this.categories[index]];
        this.updateSortOrder();
      }
    },
    moveToTop(index) {
      if (index > 0) {
        const item = this.categories.splice(index, 1)[0];
        this.categories.unshift(item);
        this.updateSortOrder();
      }
    },
    moveToBottom(index) {
      if (index < this.categories.length - 1) {
        const item = this.categories.splice(index, 1)[0];
        this.categories.push(item);
        this.updateSortOrder();
      }
    },
    async updateSortOrder() {
      const sortedCategories = this.categories.map((category, index) => ({
        id: category.id,
        sort_order: index + 1
      }));
      try {
        this.showLoading("处理中...");
        await axios.post('https://www.xinzhilian.top/product_flask/update_sort_order', sortedCategories, { withCredentials: true });
        this.$message.success("排序已更新");
        await this.fetchCategories();
      } catch (error) {
        this.$message.error("排序更新失败");
      } finally {
        await this.hideLoading();
      }
    },
    showLoading(message) {
      this.loadingStartTime = Date.now();
      this.loadingInstance = Loading.service({
        lock: true,
        text: message,
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    // async hideLoading() {
    //   const loadingDuration = Date.now() - this.loadingStartTime;
    //   if (loadingDuration < this.MIN_LOADING_TIME) {
    //     await new Promise(resolve => setTimeout(resolve, this.MIN_LOADING_TIME - loadingDuration));
    //   }
    //   if (this.loadingInstance) {
    //     this.loadingInstance.close();
    //     this.loadingInstance = null;
    //   }
    // },

    async fetchFolderStructure() {
      const databaseName = localStorage.getItem('database_name');
      try {
        const response = await axios.post('https://www.xinzhilian.top/product_flask/get_folder_structure', {
          database_name: databaseName
        }, { withCredentials: true });
        this.folderStructure = response.data.map(item => this.processNode(item));
      } catch (error) {
        console.error("获取文件夹结构失败:", error);
      }
    },
    processNode(node, parentPath = "") {
      const fullPath = parentPath ? `${parentPath}/${node.label}` : node.label;
      node.fullPath = fullPath;
      if (node.children) {
        node.isFolder = true;
        node.children = node.children.map(child => this.processNode(child, fullPath));
      } else {
        node.isFolder = false;
      }
      return node;
    },
    // handleSingleSelect(node) {
    //   if (node.isFolder) {
    //     this.selectedFolder = node.fullPath;
    //     this.fetchImagesInFolder(); // 新增：获取文件夹内图片
    //   } else {
    //     this.selectedFolder = "";
    //     this.$message.warning("请选择一个文件夹，而不是文件。");
    //   }
    // },
    handleSingleSelect(node) {
      // node 是后端返回的节点对象，现在包含了 id, label, children 等
      this.selectedFolder = node.label; // 界面上显示当前选中的文件夹名字
      
      // 【修改核心】：记录当前选中的文件夹 ID
      this.currentFolderId = node.id; 

      // 【新增这一行】切换文件夹时，必须回到第一页
      this.currentPage = 1; 
      
      // 获取该文件夹下的图片
      this.fetchImagesInFolder(); 
    },
    // async fetchImagesInFolder() {
    //   // 新增：获取选中文件夹内的图片
    //   const databaseName = localStorage.getItem('database_name');
    //   const token = localStorage.getItem('jwt_token');
    //   try {
    //     const response = await axios.post(
    //       'https://www.xinzhilian.top/product_flask/get_images_in_folder', // 替换为你的后端图片获取 API
    //       {
    //         database_name: databaseName,
    //         folderPath: this.selectedFolder
    //       },
    //       {
    //         headers: { Authorization: `Bearer ${token}` },
    //         withCredentials: true
    //       }
    //     );
    //     this.imageFiles = response.data.images; // 假设 API 返回的图片路径列表字段为 `images`
    //     // console.log("imageFiles",this.imageFiles)
    //   } catch (error) {
    //     console.error("获取文件夹内图片失败:", error);
    //     this.$message.error("获取图片失败");
    //   }
    // },
    async fetchImagesInFolder() {
      const databaseName = localStorage.getItem('database_name');
      const token = localStorage.getItem('jwt_token');
      const folderId = this.currentFolderId || 0;

      try {
        const response = await axios.post(
          'https://www.xinzhilian.top/product_flask/get_images_in_folder',
          {
            database_name: databaseName,
            folder_id: folderId,
            
            // 【新增】传分页参数
            page: this.currentPage,
            per_page: this.pageSize
          },
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true
          }
        );
        
        this.imageFiles = response.data.images;
        
        // 【新增】更新总数，用于分页控件显示
        this.totalImages = response.data.total; 
        
      } catch (error) {
        console.error("获取图片失败:", error);
        this.imageFiles = [];
        this.totalImages = 0;
      }
    },
    // 【251205新增】处理页码改变 (点击第几页)
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchImagesInFolder();
    },

    // 【251205新增】处理每页条数改变 (比如从20条变50条)
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 重置回第一页
      this.fetchImagesInFolder();
    },
    // 清除已选文件夹，回到根目录
    // clearSelectedFolder() {
    //   this.selectedFolder = "";
    //   this.imageFiles = []; // 清空图片展示
    //   this.$message.info("已返回根目录");

    //   // 取消树形控件的选中状态
    //   if (this.$refs.folderTree) {
    //     this.$refs.folderTree.setCurrentKey(null);
    //   }
    // },
    clearSelectedFolder() {
      this.selectedFolder = "";
      // 【修改核心】：重置为根目录 ID
      this.currentFolderId = 0; 
      
      this.imageFiles = []; 
      this.$message.info("已返回根目录");

      if (this.$refs.folderTree) {
        this.$refs.folderTree.setCurrentKey(null);
      }
      
      // 可选：返回根目录后，你可以选择清空图片，或者加载根目录的图片
      // this.fetchImagesInFolder(); 
    },
    openCreateFolderDialog() {
      this.createFolderDialogVisible = true;
    },
    async createFolder() {
      const databaseName = localStorage.getItem('database_name');
      const token = localStorage.getItem('jwt_token');

      if (!this.newFolderName.trim()) {
        this.$message.error("文件夹名称不能为空");
        return;
      }

      // 【修改核心】：使用 currentFolderId，如果未定义或为0，则代表根目录
      const parentId = this.currentFolderId || 0;

      await this.runWithMinLoading(async () => {
        try {
          await axios.post(
            'https://www.xinzhilian.top/product_flask/create_folder',
            {
              database_name: databaseName,
              // 【修改点】：参数改为 parent_id
              parent_id: parentId, 
              folderName: this.newFolderName
            },
            {
              headers: {
                Authorization: `Bearer ${token}`
              },
              withCredentials: true
            }
          );
          this.$message.success("文件夹创建成功");
          this.createFolderDialogVisible = false;
          this.newFolderName = ""; // 清空输入框
          
          // 刷新列表
          this.fetchFolderStructure(); 
        } catch (error) {
          const errorMessage = error.response?.data?.error || "创建文件夹失败";
          if (error.response && error.response.status === 400 && errorMessage.includes("已存在")) {
            this.$message.error("当前目录下已有同名文件夹");
          } else {
            this.$message.error(errorMessage);
          }
        }
      }, "处理中...");
    },
    async deleteFolder() {
      // 1. 校验：不能删根目录
      if (!this.currentFolderId || this.currentFolderId === 0) {
          this.$message.warning("请先选择要删除的文件夹（根目录不可删除）");
          return;
      }

      const databaseName = localStorage.getItem('database_name');
      const token = localStorage.getItem('jwt_token');

      this.$confirm('确定要删除此文件夹吗？该文件夹下的所有子文件夹和图片都将被永久删除！', '高危操作警告', {
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(async () => {
          await this.runWithMinLoading(async () => {
              try {
                  // 2. 发送请求
                  await axios.post(
                      'https://www.xinzhilian.top/product_flask/delete_folder',
                      {
                          database_name: databaseName,
                          // 【关键】传 ID
                          folder_id: this.currentFolderId
                      },
                      {
                          headers: { Authorization: `Bearer ${token}` },
                          withCredentials: true
                      }
                  );
                  
                  this.$message.success("文件夹删除成功");

                  // 3. 重置状态：回到根目录
                  this.clearSelectedFolder(); 
                  
                  // 4. 刷新文件夹树
                  this.fetchFolderStructure();
                  
                  // 5. 刷新空间占用 (因为删了一堆图，空间肯定变了)
                  this.getFolderSize();

              } catch (error) {
                  const errMsg = error.response?.data?.error || "删除文件夹失败";
                  this.$message.error(errMsg);
              }
          }, "正在清理数据...");
      }).catch(() => {
          this.$message.info("已取消");
      });
    },
    async runWithMinLoading(task, message) {
      this.showLoading(message);
      const startTime = Date.now();
      try {
        await task();
      } finally {
        const elapsed = Date.now() - startTime;
        const remaining = this.MIN_LOADING_TIME - elapsed;
        if (remaining > 0) {
          setTimeout(() => this.hideLoading(), remaining);
        } else {
          this.hideLoading();
        }
      }
    },
    showLoading(message) {
      this.loadingInstance = Loading.service({
        lock: true,
        text: message,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    hideLoading() {
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
    },
    logout() {
      // 清除本地存储中的 token 和数据库名称
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('database_name');
      // 导航到登录页面
      this.$router.push('/login');
    },
    showEditDialog(category) {
      this.editCategoryDialogVisible = true;
      this.editCategoryName = category.name;
      this.currentEditCategoryId = category.id; // 保存当前正在编辑的类目ID
    },
    updateCategory() {
      // 判断输入是否为空
      if (!this.editCategoryName.trim()) {
        this.$message.error('类目名称不能为空');
        return;
      }
      
      // 调用API更新类目
      axios.put(`https://www.xinzhilian.top/product_flask/update_category/${this.currentEditCategoryId}`, {
        name: this.editCategoryName
      })
      .then(response => {
        // 更新本地数据
        const index = this.categories.findIndex(cat => cat.id === this.currentEditCategoryId);
        if (index !== -1) {
          this.categories[index].name = this.editCategoryName;
        }
        
        this.$message.success('类目修改成功');
        this.editCategoryDialogVisible = false;
      })
      .catch(error => {
        console.error('更新类目失败:', error);
        if (error.status === 400) {
          this.$message.error("类目名称已存在");
        }
        else {
          this.$message.error("更新类目失败");
        }
       
      });
    },
  },
  watch: {
      selectAll(newVal) {
          this.handleSelectAll();
      },
      products: {
          deep: true,
          handler() {
              this.selectAll = this.products.every(product => product.checked);
          }
      }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.fetchCategories();
    this.getFolderSize();  // 初始化获取文件夹大小
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },

  // 添加 computed 属性，用于动态控制弹窗宽度
  computed: {
    // 小弹窗宽度 (原30%)
    dialogWidthSmall() {
      return this.isMobile ? '90%' : '30%';
    },
    // 大弹窗宽度 (原50%)
    dialogWidthLarge() {
      return this.isMobile ? '95%' : '50%';
    }
  }
};
</script>


<style scoped>
.admin-container {
  display: flex;
  height: 98vh;
}

.sidebar {
  height: 100%;
  background-color: #001529;
  color: white;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  background-color: #2c3e50;
}

.page-title {
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  margin: 0;
}

.el-main {
  padding: 20px;
}

.el-menu {
  width: 100%;
  border-right: none;
}

.el-menu-item {
  width: 100%;
  text-align: center;
  background-color: #2c3e50;
  color: #ffffff; /* 未选中时文字为白色 */
}

.el-menu-item:hover {
  color: #1f1919; /* 悬浮时的颜色，可以调整 */
}

.el-menu-item.is-active {
  background-color: #1f2d3d;
  color: #ffd700; /* 选中时的文字颜色（示例为金色） */
  font-weight: bold; /* 选中时加粗 */
}

.clear-button-circle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-left: 5px;
  background-color: #f56c6c;
  color: white;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
}

.image-gallery {
  padding: 20px;
}

.image-gallery-flex {
  display: flex;
  flex-wrap: wrap; /* 自动换行 */
  gap: 20px; /* 控制间距 */
}

.image-card {
  width: 180px; /* 控制卡片宽度 */
  margin-bottom: 20px;
}

.image-container {
  width: 100%;
  height: 150px; /* 调整高度 */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 确保图片完整显示 */
}

.image-preview_add {
  max-width: 200px; /* 根据需求调整宽度 */
  max-height: 200px; /* 根据需求调整高度 */
  object-fit: contain; /* 确保图片完整显示在限制范围内 */
  border: 1px solid #dcdfe6;
  padding: 5px;
  background-color: #f5f5f5;
}


.image-actions {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.space-info {
  margin-top: 10px;
  font-weight: bold;
  color: #333;
}

.image-selector {
  cursor: pointer;
  border: 1px dashed #dcdfe6;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-preview-small {
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
}

.image-placeholder-icon {
  font-size: 36px;
  color: #dcdfe6;
}

.upload-section {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload-button {
  margin-right: 10px;
}

.upload-tip {
  color: red;
  font-size: 12px;
}

/* 调整表格宽度和规格图片样式 */
.el-table {
  width: 100%;
  margin: 0 auto;
}

.spec-image-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.spec-image {
  width: 80px; /* 调整宽度 */
  height: 80px; /* 调整高度 */
  object-fit: cover;
  border-radius: 5px;
  border: 1px solid #dcdfe6;
}

/* 预览图片样式 */
.preview-image {
  max-width: 70%; /* 最大宽度为窗口的 70% */
  max-height: 70%; /* 最大高度为窗口的 70% */
  display: block;
  margin: 0 auto;
  object-fit: contain; /* 确保图片保持比例缩放 */
}

/* 对话框整体样式 */
.preview-dialog .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #f5f5f5;
}

.custom-dialog {
  text-align: center;
}

.section-title {
  text-align: left; /* 左对齐 */
  margin: 20px 0 10px; /* 调整标题的上下间距 */
  font-size: 18px; /* 标题字体大小 */
  font-weight: bold; /* 字体加粗 */
  color: #333; /* 标题颜色 */
  border-left: 4px solid #409EFF; /* 左侧添加一条蓝色线条（可选） */
  padding-left: 10px; /* 内边距，防止文字紧贴线条 */
}

.button-container {
  display: flex;
  justify-content: center; /* 居中对齐 */
  margin-top: 20px; /* 顶部间距 */
  padding-top: 20px; /* 顶部内边距 */
  border-top: 1px solid #e8e8e8; /* 顶部分隔线 */
}

.button-container .el-button {
  margin: 0 10px; /* 按钮左右间距 */
}

.sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  background-color: #2c3e50;
  color: #ffffff;
}

.personal-center {
  margin-top: auto; /* 自动占据顶部空间，将个人中心推到底部 */
  width: 100%;
  padding-bottom: 10px; /* 底部留一些间距 */
}

.logout-button {
  width: 100%;
  text-align: center;
  background-color: #2c3e50;
  color: #ffffff; /* 未选中时文字为白色 */
}

.logout-button:hover {
  color: #1f1919; /* 悬浮时的颜色，可以调整 */
}

.logout-button.is-active {
  background-color: #1f2d3d;
  color: #ffd700; /* 选中时的文字颜色（示例为金色） */
  font-weight: bold; /* 选中时加粗 */
}

.product-draggable-container {
  width: 100%;
  margin-top: 20px;
}
.product-item {
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
}
.product-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.product-info {
  display: flex;
  align-items: center;
  gap: 20px;
}
.product-name {
  font-weight: bold;
  min-width: 150px;
}
.product-price {
  color: #f56c6c;
  min-width: 80px;
}
.product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
.product-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.product-drag-handle {
  cursor: move;
  font-size: 20px;
  color: #409EFF;
  margin-right: 15px;
}

/* 拖拽排序相关样式 */
.drag-handle {
  cursor: move;
  font-size: 20px;
  color: #409EFF;
  margin-right: 5px;
}

.drag-list-container {
  margin-top: 20px;
}
.drag-list {
  list-style: none;
  padding: 0;
}
.drag-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: #fff;
  transition: all 0.3s;
}
.drag-item:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.drag-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.drag-item-left {
  display: flex;
  align-items: center;
  gap: 5px; /* 减小间隙 */
}
.drag-item-right {
  display: flex;
  align-items: center;
  justify-content: flex-end; /* 靠右对齐 */
  gap: 5px; /* 按钮之间的间距 */
}
.drag-title {
  font-weight: bold;
  margin-bottom: 10px;
}
.drag-title h3 {
  margin: 0;
  color: #409EFF;
}
.item-name {
  font-weight: bold;
  font-size: 16px;
}
.product-drag-item {
  background-color: #f9f9f9;
}
.product-drag-item .product-info {
  display: flex;
  align-items: center;
  gap: 15px;
}
.product-drag-item .product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}
.product-drag-item .product-price {
  color: #f56c6c;
  font-weight: bold;
}
.no-products {
  text-align: center;
  margin-top: 20px;
  color: #909399;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
}

.spec-draggable-container {
  width: 100%;
  margin-bottom: 20px;
}
.spec-item {
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 15px;
  border-radius: 4px;
  background-color: #fff;
}
.spec-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}
.spec-field {
  flex: 1;
  min-width: 200px;
}
.spec-field label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.spec-image-field {
  flex: 1.5;
}
.spec-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.spec-drag-handle {
  cursor: move;
  font-size: 20px;
  color: #409EFF;
  margin-right: 5px;
}

.product-draggable-container {
  width: 100%;
  margin-top: 20px;
}
.product-item {
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
}
.product-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.product-info {
  display: flex;
  align-items: center;
  gap: 10px; /* 减小间距 */
}
.product-name {
  font-weight: bold;
  min-width: 150px;
}
.product-price {
  color: #f56c6c;
  min-width: 80px;
}
.product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
.product-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.product-drag-handle {
  cursor: move;
  font-size: 20px;
  color: #409EFF;
  margin-right: 15px;
}

.category-draggable-list {
  margin-top: 20px;
}
.category-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.category-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
}
.category-content {
  display: flex;
  align-items: center;
  gap: 10px;
}
.category-name {
  font-weight: bold;
}
.category-actions {
  display: flex;
  align-items: center;
  gap: 5px;
}

.drag-list-container {
  margin-top: 20px;
}
.drag-list {
  list-style: none;
  padding: 0;
}
.drag-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-bottom: 10px;
}
.drag-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.drag-item-left {
  display: flex;
  align-items: center;
  gap: 5px; /* 缩小选择框和商品信息之间的间隔 */
}
.drag-item-right {
  display: flex;
  align-items: center;
  gap: 10px;
}
.drag-title {
  font-weight: bold;
  margin-bottom: 10px;
}
.drag-title h3 {
  margin: 0;
  color: #409EFF;
}
.item-name {
  font-weight: bold;
  font-size: 16px;
}
.product-drag-item {
  background-color: #f5f5f5;
}
.no-products {
  text-align: center;
  margin-top: 20px;
  color: #909399;
}

.item-name {
  font-weight: bold;
  font-size: 16px;
}

.drag-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  background-color: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px 4px 0 0;
  font-weight: bold;
  margin-bottom: 5px;
}
.drag-header-item {
  /* display: flex; */
  align-items: center;
}
.text-right {
  text-align: right;
}
.flex-start {
  display: flex;
  align-items: center;
  padding-left: 10px; /* 调整内边距 */
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

/* =================================
   移动端响应式样式适配 (Max Width 768px)
   ================================= */
@media screen and (max-width: 768px) {
  /* 1. 容器与布局 */
  .admin-container {
    overflow-x: hidden; /* 防止横向滚动 */
  }
  
  /* 2. 侧边栏 (抽屉式效果) */
  .sidebar {
    position: fixed;
    top: 0;
    left: -200px; /* 默认隐藏在左侧屏幕外 */
    height: 100vh;
    z-index: 2000;
    transition: all 0.3s ease;
    width: 200px !important; /* 强制固定宽度 */
  }
  
  .sidebar.sidebar-mobile-open {
    left: 0; /* 滑出 */
  }

  /* 遮罩层 */
  .sidebar-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1999;
  }

  .mobile-close-btn {
    position: absolute;
    right: 10px;
    top: 15px;
    font-size: 20px;
    cursor: pointer;
    color: #fff;
  }

  /* 3. 移动端 Header */
  .mobile-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  .mobile-title {
    margin-left: 10px;
    font-weight: bold;
    font-size: 16px;
  }

  /* 4. 通用内容区调整 */
  .el-main {
    padding: 10px; /* 减小内边距 */
  }

  /* 5. 拖拽列表 (Draggable List) 响应式 */
  .drag-header {
    display: none; /* 手机端隐藏表头，改为卡片式展示 */
  }

  .drag-item {
    margin-bottom: 15px;
  }

  .drag-item-content {
    flex-direction: column; /* 内容垂直排列 */
    align-items: flex-start;
  }

  .drag-item-left {
    width: 100%;
    margin-bottom: 10px;
    justify-content: flex-start;
  }
  
  .drag-item-right {
    width: 100%;
    justify-content: flex-end; /* 按钮靠右 */
    margin-top: 5px;
    border-top: 1px solid #eee;
    padding-top: 10px;
  }
  
  /* 列表中的图片和文字适配 */
  .product-info {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden; /* 防止文字撑开 */
  }
  
  .item-name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 5px;
  }

  /* 6. 图片空间操作区 */
  div[style*="display: flex; align-items: center; justify-content: center; margin-bottom: 20px;"] {
    flex-wrap: wrap; /* 按钮自动换行 */
    justify-content: flex-start !important;
  }
  
  div[style*="display: flex"] > .el-button,
  div[style*="display: flex"] > .el-dropdown {
    margin-bottom: 10px;
    margin-left: 0 !important;
    margin-right: 10px;
  }

  /* 7. 图片卡片 (一行两列) */
  .image-gallery-flex {
    justify-content: space-between;
  }
  
  .image-card {
    width: 45%; /* 一行两个 */
    margin-right: 0;
  }
  
  .image-container {
    height: 100px; /* 图片高度减小 */
  }

  /* 8. 规格设置 (Spec Rows) */
  .spec-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .spec-field, .spec-image-field {
    width: 100%;
    min-width: unset;
    margin-bottom: 10px;
  }
  
  .spec-actions {
    width: 100%;
    justify-content: flex-end;
  }

  /* 9. 表单项调整 */
  .el-form-item__label {
    float: none; /* 标签变更为上方显示 */
    display: block;
    text-align: left;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
  
  /* 10. 对话框内部 Tree 控件容器 */
  .el-dropdown-menu {
    max-width: 90vw; /* 防止树形菜单撑开屏幕 */
  }
}

</style>
